import React from 'react'
import DashboardMaster from '../../../../dashboard/DashboardMaster'
import AssetContent from './AssetContent'

const Assets = () => {
  return (
    <DashboardMaster>
      <AssetContent />
    </DashboardMaster>
  )
}

export default Assets
